<i18n src="./translations"></i18n>

<template>
  <PdpTabExpandableContent :headline="$t('pdp-tab-hints.headline')">
    <!-- eslint-disable vue/no-v-html -->
    <div class="content" v-html="$t(`pdp-tab-hints.content.${articleType}`)" />
  </PdpTabExpandableContent>
</template>

<script>
import PdpTabExpandableContent from 'Components/02-molecules/pdp-tab-expandable-content/PdpTabExpandableContent.vue';

export default {
  name: 'PdpTabHints',
  components: { PdpTabExpandableContent },
  props: {
    articleType: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

::v-deep {
  .content {
    font-size: var(--font-size-M);
    line-height: var(--font-size-MLL);

    a {
      color: var(--color-secondary);
      text-decoration: underline;
    }

    p + p {
      margin-top: 1em;
    }
  }
}
</style>
